<script lang="ts" setup></script>

<template>
	<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M21.5 9.27771L13 13.9999M13 13.9999L4.49997 9.27771M13 13.9999L13 23.5M15 22.8889L13.777 23.5683C13.4934 23.7258 13.3516 23.8046 13.2015 23.8355C13.0685 23.8628 12.9315 23.8628 12.7986 23.8355C12.6484 23.8046 12.5066 23.7258 12.223 23.5683L4.82297 19.4572C4.52346 19.2908 4.37368 19.2076 4.26463 19.0892C4.16816 18.9845 4.09515 18.8605 4.05048 18.7253C4 18.5725 4 18.4012 4 18.0585V9.94141C4 9.59877 4 9.42744 4.05048 9.27465C4.09515 9.13947 4.16816 9.01539 4.26463 8.9107C4.37368 8.79236 4.52345 8.70916 4.82297 8.54276L12.223 4.43165C12.5066 4.27409 12.6484 4.19531 12.7986 4.16442C12.9315 4.13709 13.0685 4.13709 13.2015 4.16442C13.3516 4.19531 13.4934 4.27409 13.777 4.43164L21.177 8.54276C21.4766 8.70916 21.6263 8.79236 21.7354 8.9107C21.8318 9.01539 21.9049 9.13947 21.9495 9.27464C22 9.42744 22 9.59876 22 9.94141L22 14.5M8.5 6.49996L17.5 11.5M17 20L19 22L23 18"
			stroke="black"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<style scoped lang="scss"></style>
